<template>
  <div class="my-swiper">
    <swiper ref="mySwiper" :options="swiperOption">
      <swiper-slide>
        <div class="image-box">
          <img src="./images/im.png" alt="" />
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="image-box">
          <img src="./images/order.png" alt="" />
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="image-box">
          <img src="./images/voice-room.png" alt="" />
        </div>
      </swiper-slide>
    </swiper>
    <div class="action-box">
      <img src="./images/left.png" alt="" @click="handlePrevClick" />
      <div class="pagination">
        <span
          class="pagination-item"
          v-for="i in 3"
          :key="i"
          :class="{ active: i == 2 }"
          @click="slideTo(i + 1)"
        ></span>
      </div>
      <img src="./images/right.png" alt="" @click="handleNextClick" />
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
export default {
  name: 'MySwiper',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {},
  data() {
    return {
      swiperOption: {
        loop: true,
        // autoplay: {
        //   delay: 2000,
        //   disableOnInteraction: true
        // },
        slidesPerView: 3, // 同时显示的Slide数量
        centeredSlides: true, // 中间的Slide是否对齐容器中心
        // spaceBetween: '26px', // Slide之间的间隔
        slideClass: 'custom-slide-class',
        navigation: {
          nextEl: null,
          prevEl: null
        }
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'custom' // 自定义指示器
        // }
      },
      activeIndex: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    handlePrevClick() {
      this.$refs.mySwiper.$swiper.slidePrev(); // 切换到上一个Slide
    },
    handleNextClick() {
      this.$refs.mySwiper.$swiper.slideNext(); // 切换到下一个Slide
    },
    slideTo(index) {
      this.$refs.mySwiper.$swiper.slideTo(index);
    }
  }
};
</script>
<style lang="scss" scoped>
.my-swiper {
  width: 600px;
  height: 480.67px;
  position: absolute;
  top: 1294.22px;
  left: 191px;
  z-index: 2;
  overflow: hidden;
  // img {
  //   width: 340px;
  //   height: 285.83px;
  // }
  /deep/ .swiper-wrapper {
    .custom-slide-class {
      img {
        width: 0;
        height: 0;
      }
      .image-box {
        position: relative;
        width: calc(700px / 3);
        height: 427px;
      }
    }
    .swiper-slide-active {
      img {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-52.8%);
        width: 480px;
        height: auto;
        z-index: 2;
      }
    }
    .swiper-slide-prev {
      img {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(-49%, -50%);
        width: 380px;
        height: 337.78px;
      }
    }
    .swiper-slide-next {
      img {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(80%, -50%);
        width: 380px;
        height: 337.78px;
      }
    }
  }
  .action-box {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 494px;
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    img {
      width: 52px;
      height: 54px;
      cursor: pointer;
    }
    .pagination {
      width: 370px;
      height: 10px;
      background: #ccf0ff;
      border: 2px solid #23488c;
      border-radius: 10px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .pagination-item {
        width: 170px;
        height: 10px;
        &.active {
          background: #ffe353;
          border: 2px solid #23488c;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
